import { ANSWERS_HATCH_ROUTE } from './constants';
import { TEXT_ANSWERS_HATCH_ROUTE } from './text/constants';
import { IMAGE_ANSWERS_HATCH_ROUTE } from './image/constants';
import { SCALE_ANSWERS_HATCH_ROUTE } from './scale/constants';
import { FREE_TEXT_ANSWERS_HATCH_ROUTE } from './freeText/constants';
import { TEXT_POLL_ANSWERS_HATCH_ROUTE } from './textPoll/constants';

import http from '../../../../utils/httpService';

/**
 *
 * @param type
 * @returns {string}
 */
const getRouteByQuestionType = type => {
    switch ( type ) {
        case 'text':
            return TEXT_ANSWERS_HATCH_ROUTE;
        case 'image':
            return IMAGE_ANSWERS_HATCH_ROUTE;
        case 'scale':
            return SCALE_ANSWERS_HATCH_ROUTE;
        case 'free_text':
            return FREE_TEXT_ANSWERS_HATCH_ROUTE;
        case 'text_poll':
            return TEXT_POLL_ANSWERS_HATCH_ROUTE;
        default:
            return ANSWERS_HATCH_ROUTE;
    }
};

/**
 *
 * @param questionID
 * @param answer
 * @param localizationId
 * @param questionType
 * @param resolve
 */
const requestAnswerCreation = ( questionID, answer, localizationId, questionType, resolve ) => {
    const answerBody = {
        question_localization_id: localizationId,
        ...answer
    };

    const route = getRouteByQuestionType( questionType );
    const formData = new FormData();
    Object.keys( answerBody ).forEach( key => formData.append( key, answerBody[ key ] ) );
    return http.request( route, 'POST', formData, true, resolve );
};
/**
 *
 * @param questionID
 * @param answerId
 * @param answer
 * @param localizationID
 * @param questionType
 * @param resolve
 */
const requestAnswerUpdating = ( questionID, answerId, answer, localizationID, questionType, resolve ) => {

    const answerBody = {
        question_localization_id: localizationID,
        ...answer
    };

    const route = getRouteByQuestionType( questionType );
    return http.request( route + `/${ answerId }`, 'PUT', answerBody, false, resolve );
};
/**
 *
 * @param answerId
 * @param questionType
 */
const requestAnswerDeleting = ( answerId, questionType ) => {
    const route = getRouteByQuestionType( questionType );
    return http.request( route + `/${ answerId }`, 'DELETE' );
};

export {
    requestAnswerCreation,
    requestAnswerUpdating,
    requestAnswerDeleting
};